<template>
  <div>
    <v-card
    class="mb-4"
    v-for="(message, index) in messages"
    :key="`message-${index}`"
    >
        <v-card-text>
            <p>{{ message.message }}</p>
            <div>
                <single-file-item v-for="file in message.files"
                              :key="`file-${file.id}`"
                              :file="file"/>
            </div>
            <v-divider/>
            <div class="mt-2">
              <strong>{{ $t('Sent by') }}</strong>: {{ message.user.name }} | {{ utcToLocalDateTimeLess(message.created_at) }}
            </div>
        </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SingleFileItem from '@/components/SingleFileItem'
import { utcToLocalDateTimeLess } from '@utils'

export default {
  components: {
    SingleFileItem
  },

  props: {
    messages: {
      type: Array,
      required: true
    }
  },

  methods: {
    utcToLocalDateTimeLess
  }
}
</script>
